__turbopack_context__.v({
  "closeModalButton": "Terms-module__7_D9JW__closeModalButton",
  "termsOfUseContainer": "Terms-module__7_D9JW__termsOfUseContainer",
});
